export const SIDEBAR_CONSTANTS = {
  WIDTHS: {
    MINI: '200px',
    FULL: '304px',
    ACTION: '72px'
  },
  BREAKPOINTS: {
    DRAWER: 'sm'
  },
  TYPES: {
    FULL: 'full',
    MINI: 'mini',
    DRAWER: 'drawer'
  },
  COLORS: {
    ACTIVE_BACKGROUND: '#EAF4FE',
    ACTIVE_TEXT: '#3096F5',
    DEFAULT_TEXT: 'rgba(0, 0, 0, 0.6)',
    HOVER_BACKGROUND: 'rgb(229, 229, 229)'
  }
}; 